<template>
  <div v-if="DEPLOY_MODE!='production'">
    <v-container >
      
      <v-layout row wrap class="ma-0">
        <v-spacer></v-spacer>
        <v-flex text-xs-right>
          <span class="caption red--text">confidential page</span>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex text-xs-left>
          groma &nbsp;&gt;&nbsp; <a href="./">AprilTag</a>  &nbsp;&gt; &nbsp; Quanti <br/>
          tag print page is <a href="./download" >here</a>.
        </v-flex>
      </v-layout>
      
      <div class="ma-2">
        <h1>Gallery (iPad)</h1>
        <p>iPadを用いるとより遠い距離からでも検知することができます</p>
      </div>
      
      <v-layout row wrap>
        <v-flex v-for="i in 3"  xs12 sm4 :key="i">
          <img  height="400" :src="'/img/AprilTag/QuantiPhotos/parts-'+i+'.jpg'" />
        </v-flex>
      </v-layout>
      
      <v-layout row wrap>
        <v-flex v-for="i in 3"  xs12 sm4 :key="i">
          <img  height="400" :src="'/img/AprilTag/QuantiPhotos/shelf-'+i+'.jpg'" />
        </v-flex>
      </v-layout>
      
      <v-layout justify-center>
          <img  class="mt-4" height="350px" src="/img/AprilTag/QuantiPhotos/shelf-0.jpg" />
      </v-layout>
      
      <h1>Movie (iPhone)</h1>
      <v-layout>
        <v-flex xs4>
          <video height="400" src="/img/AprilTag/QuantiPhotos/parts-movie.mp4" controls />
        </v-flex>
        <v-flex xs8>
          <video height="400" src="/img/AprilTag/QuantiPhotos/shelf-movie.mp4" controls />
        </v-flex>
        
      </v-layout>  
      
      <v-layout justify-center>
        <v-flex>
          <video height="400" src="/img/AprilTag/QuantiPhotos/table-movie.mp4" controls />
        </v-flex>
        
      </v-layout>
        
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'Quanti',
  metaInfo: {
    title:'groma | Quanti Gallery'
  },
  components: {
    //customerform: CustomerForm
  },
  data () {
    return {
      DEPLOY_MODE : process.env.DEPLOY_MODE
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
@media only screen and (min-width: 1264px){
  .container{
    max-width: 1185px;
  }
}

.layout {
  margin-top: 40px;
}

h1 {
  margin-top: 40px;
}

img, video {
  border: 2px solid #BBB;
}
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AprilTag/AprilTagQuanti.vue